import { render, staticRenderFns } from "./UploadFileV2.vue?vue&type=template&id=637b3f54&scoped=true"
import script from "./UploadFileV2.vue?vue&type=script&lang=js"
export * from "./UploadFileV2.vue?vue&type=script&lang=js"
import style0 from "./UploadFileV2.vue?vue&type=style&index=0&id=637b3f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b3f54",
  null
  
)

export default component.exports